import { Component, OnInit, OnDestroy, ViewContainerRef, AfterViewChecked, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, Params } from '@angular/router';
import { environment } from './../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { LmTsService } from '../../lm-ts.service';
import { LambdaFunctionService } from '../../../../service/lambda-function.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';

declare var jQuery: any;
declare var hbspt: any;
declare var toastr: any;

@Component({
  selector: 'app-dynamic-card-single',
  templateUrl: './dynamic-card-single.component.html',
  styleUrls: ['./dynamic-card-single.component.scss']
})
export class DynamicCardSingleComponent implements OnInit, OnDestroy, AfterViewChecked {

    public currentCard_id: string;
    public cardName: string;
    public currentCard: any;
    public show_card: boolean;
    private currentDate: number;
    private BeginDateTime: number;
    private EndDateTime: number;
    public plan_qmp = false;
    public plan_cmf = false;
    public plan_adf = false;
    public env: any;
    public url: any;
    public allCols: any;
    nextCard: string;
    guide: any;
    guides: any;
    email: any;
    short_guide: string;
    long_guide: string;
    previousCard: string;
    nextColumn: string;
    previousColumn: string;
    nextTitle: string;
    previousTitle: string;
    firstname = '';
    lastname = '';
    marked: boolean;
    currentLM: any = '';
    currentLM_id: any;
    lm_maptype = '';
    slides_text: any;
    current_slide_value: any;
    sl_index: number;
    slides: any;
    lm_id: string | any = '';
    main_app_enable = true;
    wistia_src: any;
    placeholderImage = 'assets/images/learner-map-placeholder.svg';
    columns: any;
    cardView = false;
    LmData: any;
    activityData: any;
    cardCheckbox = false;
    slideBackgroundImage: any;
    audio_mute = false;
    private lastSyncedCardId: any = null;

    private destroy$ = new Subject<void>();

    constructor(
        private http: HttpClient,
        private viewContainerRef: ViewContainerRef,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        private sanitizer: DomSanitizer,
        public lm_ts: LmTsService,
        public lmda_service: LambdaFunctionService,
        public oidcSecurityService: OidcSecurityService,
        public store: Store<any>,
        private elRef: ElementRef
    ) {}

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.lastSyncedCardId = null;
    }

    ngAfterViewChecked() {
        // Only sync when card ID changes (navigation), not on every change detection cycle.
        // This prevents overriding user clicks before get_lm_activity() refreshes.
        if (this.currentCard?.id && this.currentCard.id !== this.lastSyncedCardId) {
            const checkbox = this.elRef.nativeElement.querySelector('#mark' + this.currentCard.id) as HTMLInputElement;
            if (checkbox) {
                checkbox.checked = this.lm_ts?.isChecked(this.currentCard.id);
                this.lastSyncedCardId = this.currentCard.id;
            }
        }
    }

    onImgError(event: Event) {
        const img = event.target as HTMLImageElement;
        if (img && img.src !== this.placeholderImage) {
            img.src = this.placeholderImage;
        }
    }

    ngOnInit() {
        this.env = environment;
        this.email = localStorage.getItem('email');
        this.cardCheckbox = false;

        this.oidcSecurityService.checkAuth().pipe(
            takeUntil(this.destroy$)
        ).subscribe((userData) => {
            if (userData?.isAuthenticated) {
                this.email = userData.userData.email;
            }
        });

        if (this.router.url.includes('fs-reveal')) {
            this.main_app_enable = false;
            this.lm_id = localStorage.getItem('fs_reveal_lm_id');

            if (this.lm_id) {
                this.http.get(`${environment.profileURL}/api/v1/learner_maps/${this.lm_id}`).pipe(
                    takeUntil(this.destroy$)
                ).subscribe((lmRes: any) => {
                    lmRes?.learner_map?.learner_map_columns?.forEach((column) => {
                        column.learner_map_cards = column?.learner_map_cards?.filter(item => item.active !== false);
                    });
                    this.LmData = lmRes?.learner_map;
                    this.allCols = {
                        id: this.lm_id,
                        columns: lmRes?.learner_map?.learner_map_columns
                    };
                    this.lm_maptype = lmRes?.learner_map?.learner_map_type_title;
                    this.getCard();
                });
            }
            this.routerEvent();
        } else if (this.router.url.includes('challenge-navigator-print')) {
            this.initChallengeNavigatorPrint();
            this.routerEvent();
        } else {
            this.main_app_enable = true;
            this.initStandardLearnerMap();
            this.routerEvent();
        }
    }

    private initChallengeNavigatorPrint() {
        // Data is loaded by fs-slideshow via Rails API and pushed to lambda_res
        this.lmda_service.lambda_res.pipe(
            takeUntil(this.destroy$),
            filter(res => !!res && Array.isArray(res) && res.length > 0),
            take(1)
        ).subscribe((columns: any[]) => {
            // Store columns with learner_map_cards mapped to cards for navigation
            this.columns = columns.map(col => ({
                ...col,
                cards: (col.learner_map_cards || col.cards || []).filter(c => c.active !== false)
            }));
            this.getCard();
        });
    }

    private initStandardLearnerMap() {
        // Get learner map ID from parent route (since this component is at card/:id child route)
        const parentRoute = this.activatedRoute.parent;
        const lmIdSource = parentRoute ? parentRoute.params : this.activatedRoute.params;

        lmIdSource.pipe(
            takeUntil(this.destroy$),
            take(1)
        ).subscribe((params: Params) => {
            const lmId = params['id'];

            this.http.get(`${environment.profileURL}/api/v1/learner_maps/${lmId}`).pipe(
                takeUntil(this.destroy$)
            ).subscribe(
                (lmRes: any) => {
                    lmRes?.learner_map?.learner_map_columns?.forEach((column) => {
                        column.learner_map_cards = column?.learner_map_cards?.filter(item => item.active !== false);
                    });
                    this.LmData = lmRes?.learner_map;
                    this.allCols = {
                        id: lmId,
                        columns: lmRes?.learner_map?.learner_map_columns
                    };
                    this.currentLM_id = lmId;
                    this.lm_maptype = lmRes?.learner_map?.learner_map_type_title;
                    this.get_lm_activity();
                    this.getCard();
                },
                (err) => {
                    this.showError(err);
                }
            );
        });
    }

    public routerEvent() {
        this.router.events.pipe(
            takeUntil(this.destroy$),
            filter(e => e instanceof NavigationEnd)
        ).subscribe(() => {
            this.scrollToPageHeading();
            this.getCard();
        });
    }

    private scrollToPageHeading() {
        const el = document.querySelector('.page-heading') as HTMLElement;
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    public scrollDiv(id: string) {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    public getGuide() {
        for (let i = 0; i < this.guides.length; i++) {
            if (this.guides[i].language_code === this.guide) {
                this.short_guide = this.guides[i].short_guide;
                this.long_guide = this.guides[i].long_guide;
            }
        }
    }

    getColumnUsingCardId(card_id) {
        let cardDetails: any;
        this.LmData?.learner_map_columns?.forEach((col) => {
            col.learner_map_cards?.forEach((card) => {
                // Use loose equality to handle string/number mismatch (URL gives string, API may give number)
                if (card.id == card_id) {
                    cardDetails = card;
                }
            });
        });
        return cardDetails;
    }

    public getCard(card_id = '') {
        this.cardCheckbox = false;
        this.currentCard_id = card_id;
        this.BeginDateTime = undefined;
        this.EndDateTime = undefined;

        if (this.router.url.indexOf('card') !== -1) {
            this.currentCard_id = this.router.url.substring(this.router.url.indexOf('card') + 5, this.router.url.length);
        }

        if (this.currentCard_id !== '' && !this.router.url.includes('challenge-navigator-print')) {
            this.loadCardDetails();
        }

        this.loadCertificateData();

        if (this.router.url.includes('challenge-navigator-print')) {
            this.setupChallengeNavigatorCard();
        } else {
            this.setupStandardNavigation();
        }

        this.setupJQueryPlugins();
    }

    private loadCardDetails() {
        const firstName = {
            email: localStorage.getItem('email') || this.email,
            property: 'firstname'
        };
        const lastName = {
            email: localStorage.getItem('email') || this.email,
            property: 'lastname'
        };

        const data = this.getColumnUsingCardId(this.currentCard_id);
        if (!data) return;

        const card = data;
        this.currentCard = card;
        this.currentCard.title = this.currentCard?.title ? this.currentCard?.title?.replace(/[\[\]]/g, '') : '';
        this.cardName = card?.title;

        if (this.currentCard?.kind === 'Var_Wistia') {
            this.wistia_src = this.sanitizer.bypassSecurityTrustResourceUrl(
                '//fast.wistia.net/embed/iframe/' + this.currentCard?.link + '?videoFoam=true'
            );
        }

        if (this.currentCard_id === '65ddf595-c1f3-46ed-9167-2fe14770657d') {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(card['link']);
        } else if (card['link'] != null) {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                'https://www.youtube.com/embed/' + card['link'] + '?modestbranding=1&rel=0'
            );
        }

        this.currentDate = Date.now();
        if (this.currentCard.opened_at) {
            this.BeginDateTime = new Date(this.currentCard.opened_at).getTime();
        }
        if (this.currentCard.closed_at) {
            this.EndDateTime = new Date(this.currentCard.closed_at).getTime();
        }
        if (this.BeginDateTime >= this.currentDate || this.EndDateTime <= this.currentDate) {
            this.show_card = false;
        } else {
            this.show_card = true;
        }

        this.setupHubspotForms();
        this.loadCertificateNames(firstName, lastName);
        this.loadInterpretiveGuides();
    }

    private setupHubspotForms() {
        if (this.currentCard.title === 'Finish Qualification' || this.currentCard.id === '809572cc-4a3b-4c8b-a3eb-2a8b1d0edd4a') {
            this.createHubspotForm('1d4c6c5e-09c8-463e-a355-0452f5694869', '#hubspotFormQualification', 'comfortable_in_presenting_lm');
        }
        if (this.currentCard.title === 'Finish Mindset Certification' || this.currentCard.id === '930f1971-f096-4163-ac08-ab604deddec0') {
            this.createHubspotForm('4348742f-34e7-4f85-84d2-55a303ab471d', '#hubspotFormFinishMindsetCertification', 'comfortable_in_presenting_lm');
        }
        if (this.currentCard.title === 'Learner Map Complete' || this.currentCard.id === '35a46982-33d3-4594-9fd9-af24b3f98a41') {
            this.createHubspotForm('7eb0dcfc-0df6-4393-bfff-98eb154e2c1e', '#hubspotFormCertification', 'online_cmf_finished');
        }
    }

    private createHubspotForm(formId: string, target: string, checkboxField: string) {
        const email = this.email;
        this.loadHsFormsScript(() => {
            hbspt.forms.create({
                portalId: '4424590',
                formId: formId,
                target: target,
                onFormReady: ($form, ctx) => {
                    jQuery(target).find(`#email-${formId}`).val(email).change();
                    jQuery(target).find('.hs-email').hide();
                    jQuery(target).find('.hs-submit').hide();
                    const check = setInterval(() => {
                        jQuery(`#${checkboxField}-${formId}`).prop('checked', false);
                    }, 0);

                    jQuery(`${target} .hs-form-booleancheckbox`).click(() => {
                        clearInterval(check);
                        setTimeout(() => {
                            jQuery(target).find('.hs-submit input').click();
                        }, 500);
                    });
                }
            });
        });
    }

    private loadHsFormsScript(callback: () => void) {
        if (typeof hbspt !== 'undefined') {
            callback();
            return;
        }
        const existing = document.getElementById('hs-forms-script');
        if (existing) {
            existing.addEventListener('load', callback);
            return;
        }
        const script = document.createElement('script');
        script.id = 'hs-forms-script';
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.onload = callback;
        document.head.appendChild(script);
    }

    private loadCertificateNames(firstName: any, lastName: any) {
        if (!this.isCertificateCard()) return;

        this.http.post(`${environment.profileURL}/api/v1/hubspot/details`, firstName).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            res => { this.firstname = res['firstname']; },
            error => this.showError(error)
        );

        this.http.post(`${environment.profileURL}/api/v1/hubspot/details`, lastName).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            res => { this.lastname = res['lastname']; },
            error => this.showError(error)
        );
    }

    private loadInterpretiveGuides() {
        if (this.currentCard.title !== 'Interpretive Guides') return;

        this.guide = '';
        this.http.get(`${environment.assessment_admin}api/v1/interpretive_guides`).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            data => {
                this.guides = data['interpretive_guides'].sort((a, b) => a.language_name.localeCompare(b.language_name));
            },
            error => this.showError(error)
        );
    }

    private isCertificateCard(): boolean {
        const certCardIds = ['8e587549-916b-4849-a29a-c8eb05d2c7a7', '74568499-d15d-471d-99da-b08c42413799', 'e9f1bd5f-f50c-4bc6-8240-8f70c3362038', '877', '86', '311','228'];
        const certKinds = ['Var_Certificate_CMF', 'Var_Certificate_ADF', 'Var_Certificate_QMP', 'Var_Certificate_Toolset'];
        return certCardIds.includes(this.currentCard_id) || certKinds.includes(this.currentCard?.kind);
    }

    private loadCertificateData() {
        if (!this.isCertificateCard()) return;

        const data = {
            email: localStorage.getItem('email') || this.email,
            property: 'certz'
        };

        this.http.post(`${environment.profileURL}/api/v1/hubspot/details`, data).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            res => {
                if (res['certz'] != null && res['certz'] !== '') {
                    if (res['certz'].indexOf('qmp') > -1) this.plan_qmp = true;
                    if (res['certz'].indexOf('cmf') > -1) this.plan_cmf = true;
                    if (res['certz'].indexOf('adf') > -1) this.plan_adf = true;
                }
            },
            err => this.showError(err)
        );
    }

    private setupChallengeNavigatorCard() {
        this.cardView = true;
        this.allCols = { allcolumns: this.columns };
        this.show_card = true;
        this.lm_maptype = 'custom';

        this.allCols?.allcolumns?.forEach((column, i) => {
            column.cards?.forEach((card, j) => {
                const cardId = card.id?.S || card.id;
                if (cardId === this.currentCard_id) {
                    this.currentCard_id = cardId;
                    this.cardName = card?.title?.S || card?.title;
                    this.currentCard = card;
                    const link = card?.link?.S || card?.link;
                    if (link) {
                        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
                            'https://www.youtube.com/embed/' + link + '?modestbranding=1&rel=0'
                        );
                    }
                    this.setNavigationLinks(column, i, j, card, true);
                }
            });
        });
    }

    private setupStandardNavigation() {
        setTimeout(() => {
            this.allCols?.columns?.sort((a, b) => a?.position - b?.position);
            this.LmData?.learner_map_columns?.forEach((column, i) => {
                column?.learner_map_cards?.sort((a, b) => a.order - b.order);
                column?.learner_map_cards?.forEach((card, j) => {
                    if (card.id == this.currentCard_id) {
                        this.setStandardNavigationLinks(column, i, j);
                    }
                });
            });
        }, 1000);
    }

    private setNavigationLinks(column: any, i: number, j: number, card: any, isChallengeNav: boolean) {
        // Previous card
        if (j > 0) {
            this.previousCard = column.cards[j - 1]?.id;
            this.previousTitle = column.cards[j - 1]?.title;
            if (!column.cards[j - 1]?.id && i > 0) {
                const prevCol = this.allCols.allcolumns[i - 1];
                this.previousCard = prevCol.cards[prevCol.cards.length - 1]?.id;
                this.previousTitle = prevCol.cards[prevCol.cards.length - 1]?.title;
            }
        } else {
            if (i > 1) {
                const prevCol = this.allCols.allcolumns[i - 1];
                this.previousTitle = prevCol.cards[prevCol.cards.length - 1]?.title;
                this.previousCard = prevCol.cards[prevCol.cards.length - 1]?.id;
            } else {
                this.previousCard = '';
            }
        }

        // Next card
        if (j < column.cards.length - 1) {
            this.nextCard = column.cards[j + 1]?.id;
            this.nextTitle = column.cards[j + 1]?.title;
        } else {
            if (i < this.allCols.allcolumns.length - 1) {
                const nextCol = this.allCols.allcolumns[i + 1];
                this.nextTitle = nextCol.cards[0]?.title;
                this.nextCard = nextCol.cards[0]?.id;
                if (!column.cards[j + 1]?.id && i < this.allCols.allcolumns.length - 1) {
                    this.nextCard = nextCol.cards[parseInt(card.order)]?.id;
                    this.nextTitle = nextCol.cards[parseInt(card.order)]?.title;
                }
            } else {
                this.nextCard = '';
            }
        }
    }

    private setStandardNavigationLinks(column: any, i: number, j: number) {
        // Previous
        if (j > 0) {
            this.previousCard = column.learner_map_cards[j - 1].id;
            this.previousTitle = column.learner_map_cards[j - 1].title?.replace(/[\[\]]/g, '');
        } else if (i > 0) {
            const prevCol = this.LmData.learner_map_columns[i - 1];
            this.previousCard = prevCol.learner_map_cards[prevCol.learner_map_cards.length - 1].id;
            this.previousTitle = prevCol.learner_map_cards[prevCol.learner_map_cards.length - 1].title?.replace(/[\[\]]/g, '');
        } else {
            this.previousCard = '';
        }

        // Next
        if (j < column.learner_map_cards.length - 1) {
            this.nextCard = column.learner_map_cards[j + 1].id;
            this.nextTitle = column.learner_map_cards[j + 1].title?.replace(/[\[\]]/g, '');
        } else if (i < this.LmData.learner_map_columns.length - 1) {
            const nextCol = this.LmData.learner_map_columns[i + 1];
            this.nextCard = nextCol.learner_map_cards[0].id;
            this.nextTitle = nextCol.learner_map_cards[0].title?.replace(/[\[\]]/g, '');
        } else {
            this.nextCard = '';
        }
    }

    private setupJQueryPlugins() {
        if (this.router.url.includes('/learner-maps')) {
            this.scrollToPageHeading();
        }

        setTimeout(() => {
            jQuery('input[name="radioTest"]').on('ifChecked', (event) => {
                this.http.post(`${environment.profileURL}/api/v1/users/update_details.json`, { nps: parseInt(event.target.value) }).pipe(
                    takeUntil(this.destroy$)
                ).subscribe(() => {
                    toastr.options = { closeButton: true, progressBar: true, timeOut: 2000 };
                    toastr.success('Thanks for rating us!', 'Nice!');
                });
            });
            jQuery('input[name="radioTest"]').iCheck({
                checkboxClass: 'icheckbox_square-green',
                radioClass: 'iradio_square-green',
            });
        }, 1500);
    }

    public showError(error) {
        if (error.status === 500) {
            toastr.options = { closeButton: true, timeOut: 2000 };
            toastr.error('Something went wrong!', 'Sorry!');
        } else if (error.status === 422) {
            toastr.options = { closeButton: true, timeOut: 4000 };
            if (error.error?.errors?.number?.[0]) {
                toastr.error(error.error.errors.number[0], 'oops!');
            } else if (error.error?.errors?.base?.[0]) {
                toastr.error(error.error.errors.base[0], 'oops!');
            } else {
                toastr.error(error.error?.errors, 'oops!');
            }
        } else {
            toastr.options = { closeButton: true, timeOut: 2000 };
            toastr.error('Something went wrong!', 'oops!');
        }
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    get_lm_activity() {
        if (!this.currentLM_id) return;
        this.http.get(`${environment.profileURL}/api/v1/users/learner_map_card_activities?learner_map_id=${this.currentLM_id}`).pipe(
            takeUntil(this.destroy$)
        ).subscribe((res: any) => {
            this.activityData = res?.learner_map_card_activities;
            this.lm_ts.activityLM$.next(this.activityData);
        });
    }

    isCardIdExistInActivity(cardId) {
        let isExist = false;
        this.activityData?.forEach((activity) => {
            if (activity.learner_map_card_id === cardId) {
                isExist = true;
            }
        });
        return isExist;
    }

    markRead(record, event) {
        const isChecked = event.target.checked;
        this.cardCheckbox = event.target.value;

        const member_id = localStorage.getItem('member_id');

        // Validate required params before calling API
        if (!member_id || !this.currentLM_id || !record?.learner_map_column_id || !record?.id) {
            event.target.checked = !isChecked;
            toastr.options = { closeButton: true, progressBar: true, timeOut: 3000 };
            toastr.error('Unable to update card — missing required data. Please refresh and try again.', 'Error');
            return;
        }

        const baseUrl = `${environment.profileURL}/api/v1/learner_maps/${this.currentLM_id}/learner_map_columns/${record.learner_map_column_id}/learner_map_cards/${record.id}`;
        const action = isChecked ? 'add_activity.json' : 'remove_activity.json';
        const data = { activity: isChecked ? 'read' : 'unread' };

        this.http.post(`${baseUrl}/${action}`, data).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            () => {
                this.get_lm_activity();
                toastr.options = { closeButton: true, progressBar: true, timeOut: 1000 };
                toastr.success(isChecked ? 'Card has been marked!' : 'Card is unmarked!');
            },
            (error) => {
                this.get_lm_activity();
                const msg = error?.error?.errors || error?.error?.message || error?.message || 'Something went wrong! Please try again.';
                toastr.options = { closeButton: true, progressBar: true, timeOut: 3000 };
                toastr.error(msg, 'Sorry!');
            }
        );
    }
}
